import { schema } from 'normalizr';

// Objects
const adminSchema = new schema.Entity('admins');
const teamMemberSchema = new schema.Entity('teamMembers');
const bankAccountSchema = new schema.Entity('bankAccounts');
const teamSchema = new schema.Entity('teams', {
  teamMembers: new schema.Array(teamMemberSchema),
});
const organisationSchema = new schema.Entity('organisations');
const forfeitschema = new schema.Entity('forfeits');
const organisationSectionSchema = new schema.Entity('sections');
const creditCardSchema = new schema.Entity('creditCards');
const creditCardTokenSchema = new schema.Entity('creditCardTokens');
const purchaseSchema = new schema.Entity('purchases');
const tagSchema = new schema.Entity('tags');
const taggingSchema = new schema.Entity('taggings');
const groupImportSchema = new schema.Entity('groupImports');
const bulkImportSchema = new schema.Entity('bulkImports');
const organisationDataImportSchema = new schema.Entity(
  'organisationDataImports',
);
const matchPaymentSchema = new schema.Entity('matchPayments');
const refundSchema = new schema.Entity('refunds');
const orgCustomerSchema = new schema.Entity('orgCustomers');
const organisationAddressSchema = new schema.Entity('organisationAddresses');
const orgTeamSchema = new schema.Entity('orgTeams');
const paymentRequestSchema = new schema.Entity('paymentRequests');
const PaymentCollectionSchema = new schema.Entity(
  'PaymentCollections',
);
const invitationSchema = new schema.Entity('invitations');
const paymentEventSchema = new schema.Entity('paymentEvents');
const fixtureMatchSchema = new schema.Entity('fixtureMatches');
const fixtureMatchImportSchema = new schema.Entity('fixtureMatchImports');
const paymentEventImportSchema = new schema.Entity('paymentEventImports');
const organisationTagSchema = new schema.Entity('organisationTags');
const notificationConfigSchema = new schema.Entity('notificationConfigs');
const paymentTagSchema = new schema.Entity('paymentTags');
const competitionSchema = new schema.Entity('competitions');
const organisationFeeSchema = new schema.Entity('organisationFees');
const connectionSchema = new schema.Entity('connections');
const connectionRunSchema = new schema.Entity('connectionRuns');
const connectionTypeSchema = new schema.Entity('connectionTypes');
const teamConnectionSchema = new schema.Entity('teamConnections');
const receiptSchema = new schema.Entity('receipts');
const reminderSchema = new schema.Entity('reminders');
const enrolmentSchema = new schema.Entity('enrolments');
const dataImportSchema = new schema.Entity('dataImports');
const reportSchema = new schema.Entity('reports');
const subscriptionPaymentSchema = new schema.Entity('subscriptionPayments');
const stripeSessionSchema = new schema.Entity('stripeSessions');
const organisationProductSchema = new schema.Entity('organisationProducts');
const organisationSubscriptionSchema = new schema.Entity(
  'organisationSubscriptions',
);

const groupSchema = new schema.Entity('groups');
const peopleSchema = new schema.Entity('people', {
  tags: new schema.Array(tagSchema),
  taggings: new schema.Array(taggingSchema),
});
const paymentCollectionSchema = new schema.Entity('paymentCollections');
const paymentSchema = new schema.Entity('payments', {
  paymentCollections: new schema.Array(paymentCollectionSchema),
  people: new schema.Array(peopleSchema),
  groups: new schema.Array(groupSchema),
  tags: new schema.Array(tagSchema),
  taggings: new schema.Array(taggingSchema),
});
const paymentRecordSchema = new schema.Entity('paymentRecords', {
  paymentCollections: new schema.Array(paymentCollectionSchema),
  groups: new schema.Array(groupSchema),
  payments: new schema.Array(tagSchema),
  forfeits: new schema.Array(forfeitschema),
  tags: new schema.Array(tagSchema),
});
// Arrays of Objects
const teamListSchema = new schema.Array(teamSchema);
const teamMemberListSchema = new schema.Array(teamMemberSchema);
const tagListSchema = new schema.Array(tagSchema);
const taggingListSchema = new schema.Array(taggingSchema);
const groupListSchema = new schema.Array(groupSchema);
const peopleListSchema = new schema.Array(peopleSchema);
const paymentListSchema = new schema.Array(paymentSchema);
const matchPaymentListSchema = new schema.Array(matchPaymentSchema);
const refundListSchema = new schema.Array(refundSchema);
const orgCustomerListSchema = new schema.Array(orgCustomerSchema);
const organisationAddressListSchema = new schema.Array(organisationAddressSchema);
const orgTeamListSchema = new schema.Array(orgTeamSchema);
const paymentRequestListSchema = new schema.Array(paymentRequestSchema);
const PaymentCollectionListSchema = new schema.Array(
  PaymentCollectionSchema,
);
const paymentCollectionListSchema = new schema.Array(paymentCollectionSchema);
const organisationListSchema = new schema.Array(organisationSchema);
const organisationSectionListSchema = new schema.Array(
  organisationSectionSchema,
);
const walkoverListSchema = new schema.Array(forfeitschema);
const purchaseListSchema = new schema.Array(purchaseSchema);
const paymentRecordListSchema = new schema.Array(paymentRecordSchema);
const groupImportListSchema = new schema.Array(groupImportSchema);
const paymentEventListSchema = new schema.Array(paymentEventSchema);
const fixtureMatchListSchema = new schema.Array(fixtureMatchSchema);
const fixtureMatchImportListSchema = new schema.Array(fixtureMatchImportSchema);
const paymentEventImportListSchema = new schema.Array(paymentEventImportSchema);
const organisationTagListSchema = new schema.Array(organisationTagSchema);
const paymentTagListSchema = new schema.Array(paymentTagSchema);
const bankAccountListSchema = new schema.Array(bankAccountSchema);
const competitionListSchema = new schema.Array(competitionSchema);
const organisationFeeListSchema = new schema.Array(organisationFeeSchema);
const notificationConfigListSchema = new schema.Array(notificationConfigSchema);
const connectionListSchema = new schema.Array(connectionSchema);
const connectionRunListSchema = new schema.Array(connectionRunSchema);
const connectionTypeListSchema = new schema.Array(connectionTypeSchema);
const reminderListSchema = new schema.Array(reminderSchema);
const receiptListSchema = new schema.Array(receiptSchema);
const enrolmentListSchema = new schema.Array(enrolmentSchema);
const dataImportListSchema = new schema.Array(dataImportSchema);
const bulkImportListSchema = new schema.Array(bulkImportSchema);
const organisationDataImportListSchema = new schema.Array(organisationDataImportSchema);
const creditCardListSchema = new schema.Array(creditCardSchema);
const reportListSchema = new schema.Array(reportSchema);
const teamConnectionListSchema = new schema.Array(teamConnectionSchema);
const subscriptionPaymentListSchema = new schema.Array(
  subscriptionPaymentSchema,
);
const stripeSessionListSchema = new schema.Array(
  stripeSessionSchema,
);
const organisationProductListSchema = new schema.Array(
  organisationProductSchema,
);
const organisationSubscriptionListSchema = new schema.Array(
  organisationSubscriptionSchema,
);

export {
  adminSchema,
  bulkImportListSchema,
  bulkImportSchema,
  organisationDataImportListSchema,
  organisationDataImportSchema,
  bankAccountListSchema,
  bankAccountSchema,
  competitionListSchema,
  competitionSchema,
  connectionListSchema,
  connectionRunListSchema,
  connectionRunSchema,
  connectionSchema,
  connectionTypeListSchema,
  connectionTypeSchema,
  creditCardListSchema,
  creditCardSchema,
  creditCardTokenSchema,
  dataImportListSchema,
  dataImportSchema,
  enrolmentListSchema,
  enrolmentSchema,
  fixtureMatchImportListSchema,
  fixtureMatchImportSchema,
  fixtureMatchListSchema,
  fixtureMatchSchema,
  forfeitschema,
  groupImportListSchema,
  groupImportSchema,
  groupListSchema,
  groupSchema,
  invitationSchema,
  matchPaymentSchema,
  matchPaymentListSchema,
  refundSchema,
  refundListSchema,
  notificationConfigListSchema,
  notificationConfigSchema,
  orgCustomerSchema,
  orgCustomerListSchema,
  orgTeamSchema,
  orgTeamListSchema,
  organisationFeeListSchema,
  organisationFeeSchema,
  organisationListSchema,
  organisationSchema,
  organisationSectionListSchema,
  organisationSectionSchema,
  organisationTagListSchema,
  organisationTagSchema,
  paymentCollectionListSchema,
  paymentCollectionSchema,
  paymentEventImportListSchema,
  paymentEventImportSchema,
  paymentEventListSchema,
  paymentEventSchema,
  paymentRequestListSchema,
  paymentRequestSchema,
  PaymentCollectionListSchema,
  PaymentCollectionSchema,
  paymentListSchema,
  paymentRecordListSchema,
  paymentRecordSchema,
  paymentSchema,
  paymentTagListSchema,
  paymentTagSchema,
  peopleListSchema,
  peopleSchema,
  purchaseListSchema,
  purchaseSchema,
  receiptListSchema,
  receiptSchema,
  reminderListSchema,
  reminderSchema,
  teamConnectionListSchema,
  teamConnectionSchema,
  taggingListSchema,
  taggingSchema,
  tagListSchema,
  tagSchema,
  teamListSchema,
  teamMemberListSchema,
  teamMemberSchema,
  teamSchema,
  walkoverListSchema,
  reportSchema,
  reportListSchema,
  organisationAddressListSchema,
  organisationAddressSchema,
  subscriptionPaymentSchema,
  subscriptionPaymentListSchema,
  stripeSessionSchema,
  stripeSessionListSchema,
  organisationProductListSchema,
  organisationProductSchema,
  organisationSubscriptionListSchema,
  organisationSubscriptionSchema,
};
